import { render, staticRenderFns } from "./RequestPasswordChangeView.vue?vue&type=template&id=716f7ec4&scoped=true"
import script from "./RequestPasswordChangeView.vue?vue&type=script&lang=ts"
export * from "./RequestPasswordChangeView.vue?vue&type=script&lang=ts"
import style0 from "./RequestPasswordChangeView.vue?vue&type=style&index=0&id=716f7ec4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "716f7ec4",
  null
  
)

export default component.exports